import { ButtonHTMLAttributes, forwardRef } from "react";
import styled, { css } from "styled-components";
import { focusOutline } from "styles/focus";
import { ButtonTone, toneColor } from "../Button/Button.style";

// The look of a link, shared with the kit Link: the tone's text colour, an
// underline that appears on hover, the focus outline.
export const textLink = css<{ $tone: ButtonTone }>`
  color: ${({ $tone, theme }) => toneColor($tone, theme)};
  text-decoration: underline;
  text-decoration-color: transparent;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
  transition: text-decoration-color 0.2s;

  &:hover {
    text-decoration-color: currentColor;
  }

  ${focusOutline}
`;

// An action written as a link: it sits in a sentence, a heading or a card row
// and takes no room of its own. For an action that stands as a button, use
// Button; for navigation, use Link.
const Wrapper = styled.button<{ $tone: ButtonTone }>`
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  ${textLink}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration-color: transparent;
  }
`;

export interface LinkButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: ButtonTone;
}

const LinkButton = forwardRef<HTMLButtonElement, LinkButtonProps>(
  ({ tone = "primary", type = "button", ...rest }, ref) => (
    <Wrapper ref={ref} type={type} $tone={tone} {...rest} />
  ),
);

LinkButton.displayName = "LinkButton";

export default LinkButton;
